import React, { useState } from 'react'

import { MDBCol, MDBRow, MDBTabs, MDBTabsContent, MDBTabsLink, MDBTabsPane } from 'mdb-react-ui-kit'

import ChartTotal from './chartTotal'

interface Props {
    ids?: number[]
}
const TabCarrerasCharts:React.FC<Props> = ({ids})=>{
    const [fillActive, setFillActive] = useState<string>(''); 
   
    const handleFillClick = (value: string) => {
        if (value === fillActive) {
          return;
        }
        setFillActive(value);
      };
    return (<>

    <MDBRow>
        <MDBCol size='2' md={1} lg={1} sm={1} >
            <MDBTabs fill>
                <MDBTabsLink   active={true} >
                    Carreras
                </MDBTabsLink>
                {ids?.map((value, index) => (
                    <MDBTabsLink key={value} onClick={() => handleFillClick(String(value))} active={fillActive === String(value)}>
                    {index + 1}
                </MDBTabsLink>
                ))}
            </MDBTabs>
        </MDBCol>
        <MDBCol size='5'>
            <MDBTabsContent>
                {fillActive ? (<MDBTabsPane style={{marginLeft: '20px'}} open={+fillActive === ids?.find((value)=> value === Number(fillActive))}><ChartTotal key={+fillActive} id={+fillActive} /></MDBTabsPane>): <></>}
                    
            </MDBTabsContent>
        </MDBCol>
    </MDBRow>
    </>)
}
export default TabCarrerasCharts